export default __webpack_public_path__ + "static/media/calendar.73b0fbcc.svg";